import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'
import Styles from './About.css'

@CSSModules(Styles, {allowMultiple:true})
export default class AboutDei extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Diversity disclosures'
    const url = config.domain + config.routes.aboutDei
    const deiAboutGraphic = require( '../../../static/images/about/dei-about-page-graphic.png' )
    const clipboardClockGraphic = require( '../../../static/images/about/clipboard-clock-graphic.png' )
    const logoWhistleStop = require( '../../../static/images/about/whistle-stop-capital-logo.png' )

    //
    return <div>
      {container.helmet(title, '', url)}
      <ContainerDivs>
        
        
        <header styleName='header-subpage'>
          <h1 styleName='header-subpage__headline'>{title}</h1>
          <div styleName='header-subpage__image-banner--dei' />
        </header>


        <section styleName='lede-content'>
          <br/>
          <br/>
          <p styleName='lede-content__copy'>
            <b>Workplace equity ensure that all employees – regardless of their diverse characteristics – have fair access to opportunities, resources, and the support needed to reach their full potential.</b>
          </p>

          <p styleName='lede-content__copy'>
            When companies invest in fair and inclusive workplaces, they reinforce the American Dream – creating opportunities where everyone has a chance to succeed, and no group is unfairly advantaged or disadvantaged. Effective human capital management practices prioritize fair pay, inclusive hiring, strong and intentional recruitment, retention, and promotion practices, and foster a culture where all employees feel valued and empowered to contribute.
          </p>

          <p styleName='lede-content__copy'>
            A review by <i>As You Sow</i> and Whistle Stop Capital of workforce demographic data from <Link xstrong title='Capturing The Diversity Benefit (2023)' to='https://www.asyousow.org/reports/2023-capturing-the-diversity-benefit'>over 1,600 companies</Link> found statistically significant positive correlations between diversity within management teams and key financial metrics, including return on equity, return on invested capital, revenue growth, and share price performance. A diverse workforce across all levels of a company, fuels innovation, attracts top talent, and may improve risk management, resulting in an opportunity for corporate financial outperformance. 
          </p>

          <p styleName='lede-content__copy'>
            <b>Social Justice Funds</b> empowers investors to harness their personal economic power to support workplace equity, while maximizing returns.
          </p>
        </section>


        <section styleName='section-panel'>
          <h2 styleName='section-panel__headline'>
            Whistle Stop Capital
          </h2>
          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <p styleName='section-panel__copy'>
                Our diversity disclosures data is informed by in-depth research and company engagement from <Link xstrong title='Whistle Stop Capital' to='https://whistlestop.capital/'>Whistle Stop Capital</Link>, a firm that provides research and engagement strategies that support investors and companies in building strategies to address societal and sustainability issues. Whistle Stop Capital provides their clients’ comprehensive data and guidance on workplace inclusion, and has engaged with hundreds of companies on their corporate initiatives, policies, and disclosure practices. 
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={logoWhistleStop} alt='Whistle Stop Capital'  styleName='section-panel__whistle-stop-logo'/>
            </div>
          </div>
        </section>


        <section styleName='section-panel'>

          <div styleName='section-panel__content'>
            <div styleName='section-panel__copy-wrap'>
              <h2 styleName='section-panel__headline'>
                <i>As You Sow’s</i> Workplace Equity scorecard 
              </h2>
              <p styleName='section-panel__copy'>
                <i>As You Sow’s</i> workplace equity shareholder engagements are informed by the data within the <Link xstrong to='https://www.asyousow.org/report-page/workplace-equity' title='Workplace Equity Disclosure Scorecard'>Workplace Equity Disclosure Scorecard</Link>. When we engage with companies, they are asked to release their hiring, promotion, and retention rate data, as well as two or more years of EEO-1 forms.
              </p>
            </div>
            <div styleName='section-panel__image-wrap'>
              <img src={deiAboutGraphic} alt='Workplace Equity scorecard '  styleName='section-panel__dei-icon'/> 
            </div>
          </div>
        </section>


        <section styleName='section-panel'>
          <div styleName='section-panel__image-wrap'>
            <img src={clipboardClockGraphic} alt='Visit our Action Toolkit'  styleName='section-panel__graphic-image'/>
          </div>
          <h2 styleName='section-panel__headline section-panel__headline--center section-panel__headline--purple'>
            Visit our Action Toolkit
          </h2>
          <div styleName='section-panel__narrow-content'>
            <ul styleName='section-panel__list section-panel__list--flush'>
              <li>
                Learn how to make a change and align your investments with workplace equity
              </li>
              <li>
                Ask your financial advisor about Social Justice investing
              </li>
              <li>
                Push your employer to provide socially just investment options
              </li>
            </ul>

            <Link roundbutton to={config.routes.toolkit} title='Take action'>
              Take action
            </Link>
          </div>
        </section>


      </ContainerDivs>
    </div>
  }
}
